import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter, withHashLocation } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimations } from "@angular/platform-browser/animations";
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors, withInterceptorsFromDi } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { httpconfigInterceptor } from "./interceptors/httpconfig.interceptor";
import { ModalModule } from "ngx-bootstrap/modal";
import { TabsModule } from "ngx-bootstrap/tabs";
import {
  KeycloakAngularModule,
  KeycloakBearerInterceptor,
  KeycloakEventType,
  KeycloakOptions,
  KeycloakService
} from 'keycloak-angular';
import { environment } from "../environments/environment";
import { TitleCasePipe } from "@angular/common";
import { MqttModule } from "ngx-mqtt";
import { provideToastr } from 'ngx-toastr';
import {UserService} from "./services/user.service";
import {ApiService} from "./services/api.service";


function initializeKeycloak(keycloak: KeycloakService, userService: UserService, apiService: ApiService) {

  keycloak.keycloakEvents$.subscribe({
    next(event) {
      console.log('token event ', event);
      if (event.type == KeycloakEventType.OnTokenExpired) {
        console.log('token expired event');
        //alert('token expired event');
        keycloak.updateToken(180).then(resp => {
          console.log('success token update', resp);
          //alert('success token update');
        }).catch(error => {
          console.log('error token update', error);
          //alert('error token update');
        });
      }
    },
  });

  const ruta = window.location.href.split('&state=');
  const options: KeycloakOptions = {
    config: {
      realm: 'CONECTA-MAIN',
      url: 'https://keycloak.conectamobility.cl/',
      clientId: 'conecta-plataforma-public'
    },

    // Enables Bearer interceptor
    enableBearerInterceptor: environment.keyCloakBearerInterceptor,
    updateMinValidity: 7100,
    shouldUpdateToken(request) {
      return true;
    }
    //bearerPrefix: 'Bearer',
    //bearerExcludedUrls: []
  }

  options.initOptions = {
    checkLoginIframe: false
  }

  if (environment.production) {
    options.initOptions.onLoad = 'login-required';
    //options.initOptions.redirectUri = environment.keyCloakRedirectUri;
    options.initOptions.redirectUri = ruta[0];
  }

  return () =>
    keycloak.init(options).then(async (auth) => {
      console.log('exito token auth', auth);
      await userService.init();
      try {
        const resp = await firstValueFrom(apiService.getPermisos());
        userService.setPermisos(resp.data);
      } catch (error: any) {
        console.log('error obteniendo permisos', error);
      }
    }).catch(async (error: any) => {
      console.log('error keycloak init', error);

      // En dev/QA local el interceptor fuerza el Bearer en todas las peticiones,
      // asi que igual se puede cargar permisos aunque el init real de Keycloak falle
      if (!environment.production) {
        try {
          await userService.init();
        } catch (userError: any) {
          console.log('error inicializando usuario', userError);
        }
        try {
          const resp = await firstValueFrom(apiService.getPermisos());
          userService.setPermisos(resp.data);
        } catch (permisosError: any) {
          console.log('error obteniendo permisos', permisosError);
        }
        return;
      }

      keycloak.logout();
    });
}



export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withHashLocation()),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    importProvidersFrom(
      ModalModule.forRoot(),
      TabsModule,
      MqttModule.forRoot({ connectOnCreate: false })
    ), // NgxBootstrapModal
    importProvidersFrom(KeycloakAngularModule),
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService, UserService, ApiService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: KeycloakBearerInterceptor,
      multi: true
    },
    KeycloakService,
    provideHttpClient(withInterceptors([httpconfigInterceptor])),
    TitleCasePipe,
    provideToastr()
  ]
};
